<template>
  <b-row class="hp-authentication-page">
    <left-item />

    <b-col cols="12" lg="6" class="py-sm-64 py-lg-0">
      <b-row align-v="center" align-h="center" class="h-100 mx-4 mx-sm-n32">
        <b-col
          cols="12"
          md="9"
          xl="7"
          class="col-xxxl-5 px-8 px-sm-0 pt-24 pb-48"
        >
          <h1 class="mb-0 mb-sm-24">Войти</h1>
          <ValidationObserver v-slot="{ valid }">
            <b-form @submit="onSubmit" class="mt-16 mt-sm-32 mb-8">
              <validation-provider
                name="loginEmail"
                :rules="{ required: true, email: true }"
                v-slot="validationContext"
              >
                <b-form-group
                  label="Email :"
                  label-for="loginEmail"
                  class="mb-16"
                >
                  <b-form-input
                    v-model="email"
                    id="loginEmail"
                    type="email"
                    :state="getValidationState(validationContext)"
                  ></b-form-input>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="loginEmail"
                :rules="{ required: true }"
                v-slot="validationContext"
              >
                <b-form-group
                  label="Пароль :"
                  label-for="loginPassword"
                  class="mb-16"
                >
                  <b-form-input
                    v-model="password"
                    id="loginPassword"
                    type="password"
                    :state="getValidationState(validationContext)"
                  ></b-form-input>
                </b-form-group>
              </validation-provider>

              <b-button
                :disabled="!valid"
                type="submit"
                variant="primary"
                class="w-100"
              >
                Войти
              </b-button>
            </b-form>
          </ValidationObserver>
          <span class="text-danger hp-d-block hp-badge-text">
            {{ error }}
          </span>
          <div class="hp-form-info text-center">
            <span class="text-black-80 hp-text-color-dark-40 hp-caption mr-4">
              Еще нет аккаунта?
            </span>

            <b-link
              class="text-primary-1 hp-text-color-dark-primary-2 hp-caption"
              to="/pages/authentication/register"
            >
              Зарегистрироваться
            </b-link>
          </div>
          <div class="hp-form-info text-center">
            <b-link
              class="text-primary-1 hp-text-color-dark-primary-2 hp-caption"
              to="/pages/authentication/recover-password"
            >
              Забыли пароль?
            </b-link>
          </div>

          <footer-item />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BLink,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
} from "bootstrap-vue";

import LeftItem from "../LeftItem.vue";
import FooterItem from "../FooterItem.vue";
import axios from "axios";
import sha512 from "js-sha512";

export default {
  props: {
    header: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      email: "",
      password: "",
      error: "",
    };
  },
  components: {
    BRow,
    BCol,
    BButton,
    BLink,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    LeftItem,
    FooterItem,
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async onSubmit(event) {
      event.preventDefault();
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/auth/login`,
          {
            email: this.email,
            password: sha512(this.password),
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(data);
        localStorage.setItem("token", data.data.jwt);
        this.$router.replace({ path: "/" });
      } catch (e) {
        console.log(e);
        this.error = "Неправильный логин или пароль";
      }
    },
  },
};
</script>
